import * as EligibleGoal_ from './selfgoal'

export const EligibleGoals = EligibleGoal_



// WEBPACK FOOTER //
// ./src/compliancetracker/compliancetracker.ts